'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('dashboard.integrations.integration', {
            url: '/:integrationId/:copy',
            templateUrl: 'dashboard-integration/dashboard-integration.html',
            controller: 'dashboardIntegrationCtrl as ctrl',
            resolve: {

                clients: [
                    "Client","Authentication",
                    function (Client,Authentication) {
                      return Client.find({
                        filter: {
                          where:{"isOU":true},
                          include: ["owners"],
                        },
                      }).$promise.then(function (clients) {
                        if(clients.length==0)
                            return null;
                        if( Authentication.isAuthorized(['admin']))
                            return clients;
                        return clients.filter(clt=>clt.owners.find((owner) => owner.id == Authentication.currentUser()));
                      });
                    },
                  ],
                integration: ['Integration', '$stateParams', '$translate', function(Integration, $stateParams, $translate) {
                    if ($stateParams.integrationId === 'new') {
                        return {
                            name: null,
                            description: null,
                            type: null,
                            clientId: null,
                            configuration: {
                                auth: {
                                    type: "",
                                },
                                populateValues: {},
                                type: 'json',
                                typeRequest: 'data',
                                connection: {
                                    method: 'GET',
                                    url: null,
                                    staticParams: {},
                                    dynamicParams: {},
                                    headers: {},
                                    data: null
                                },
                                afterHook: null
                            }
                        };
                    }
                    
                    // Edit - Copy
                    return Integration.findById({
                            id: $stateParams.integrationId
                        })
                        .$promise
                        .then(function(integration) {

                            // Copy
                            if ($stateParams.copy === 'true') {
                                delete integration.id;
                                integration.name = $translate.instant("DASHBOARD.DASH_INTEG.COPY_TEXT") + integration.name;
                            }

                            return integration;
                        })
                        .catch(function(error) {
                            return error;
                        });
                }],
                departmentforms: ['Authentication', function (Authentication) {
                    return Authentication.loadDepartments().then(function(departments) {
                        return departments;
                    });                    
                }],
            },
            data: {
                authorizedRoles: ['admin', 'owner']
            }
        });
};
